import { ReactNode } from 'react';
import { AuthHeading, AuthShell } from '@/features/auth-shell';
import { Icon } from '@/lib/icons';
import { ResetPasswordCopy } from './reset-password.types';

type ResetPasswordShellProps = {
  currentLang: string;
  t: ResetPasswordCopy;
  children: ReactNode;
  /** The "sign in again" reminder only makes sense next to the form. */
  showSecurityNote?: boolean;
};

type ResetPasswordCardProps = {
  t: ResetPasswordCopy;
  eyebrow?: string;
  title: string;
  description?: string;
  children: ReactNode;
};

export function ResetPasswordShell({ t, children, showSecurityNote = true }: ResetPasswordShellProps) {
  return (
    <AuthShell documentTitle={t.resetPasswordFormTitle}>
      {children}
      {showSecurityNote ? (
        <p className="text-center text-xs leading-relaxed text-faint-foreground">{t.resetPasswordSecurityNote}</p>
      ) : null}
    </AuthShell>
  );
}

export function ResetPasswordCard({ eyebrow, title, description, children }: ResetPasswordCardProps) {
  return (
    <div className="space-y-7">
      <AuthHeading eyebrow={eyebrow} title={title} description={description} />
      {children}
    </div>
  );
}

export function StatusIcon({ tone }: { tone: 'danger' | 'success' }) {
  return <Icon name={tone === 'success' ? 'check' : 'alertTriangle'} className="h-5 w-5" />;
}
